import React from 'react';

const colorMap = {
  booked: 'bg-neutral7',
  selected: 'bg-primary1',
  disabled: 'bg-neutral2',
  available: 'bg-neutral4'
};

const colorRange = {
  booked: '#625E68',
  selected: '#34A5AC',
  disabled: '#EEECF1',
  available: '#BFBBC3'
};

interface BookingTimeBlockProps {
  index: number;
  hour: string;
  status: string;
  width: string;
  displayHour: boolean;
  start: number;
  end: number;
  updateStart: any;
  updateEnd: any;
  booking: any;
}

export default function BookingTimeBlock({
  hour,
  index,
  status,
  width,
  displayHour,
  start,
  end,
  updateStart,
  booking,
  updateEnd
}: BookingTimeBlockProps) {
  const bgcolor = colorMap[status as keyof typeof colorMap];
  const color = colorRange[status as keyof typeof colorMap];
  const disabled =
    status === 'disabled' || status === 'booked' ? 'pointer-events-none' : 'pointer-events-auto';

  const checkBookingOverlap = (selectedIndex: number) => {
    const selectedarray = [];
    for (let i = start; i < selectedIndex; i++) {
      selectedarray.push(i);
    }
    return selectedarray.some((i: any) => booking.includes(i));
  };

  // Handle Click event for select bookings
  const handleClick = (event: any) => {
    const selectedIndex = parseInt(event.target.id);
    if (start === 0 || start !== end) {
      updateStart(selectedIndex);
      updateEnd(selectedIndex);
    } else if (selectedIndex >= start) {
      if (checkBookingOverlap(selectedIndex)) {
        updateStart(selectedIndex);
        updateEnd(selectedIndex);
      } else {
        updateEnd(selectedIndex);
      }
    } else {
      updateStart(selectedIndex);
      updateEnd(selectedIndex);
    }
  };

  return (
    <div key={index} onClick={handleClick} className={`flex flex-col ${disabled} ${width} gap-1`}>
      <div id={index.toString()} className="w-full h-4 whitespace-nowrap text-neutral7">
        {displayHour ? hour : ''}
      </div>
      <div className="flex flex-col">
        <div
          id={index.toString()}
          className={`w-full h-8 border-r-2 ${bgcolor} border-solid border-neutral1`}
        ></div>
        <div
          id={index.toString()}
          style={{
            background: `linear-gradient(to bottom right, ${color} 0%, ${color} 50%, #FFFFFF 50%, #FFFFFF 100%)`
          }}
          className={`w-full h-2 border-r-2 border-solid border-neutral1  ${
            displayHour ? 'opacity-100' : 'opacity-0'
          } `}
        ></div>
      </div>
    </div>
  );
}
